import { NativeModule } from 'expo-modules-core';
//# sourceMappingURL=ExpoUpdatesModule.types.js.map